import styled from 'styled-components';
import { registerSteps } from 'modules/user/constants/register';

export const Header = ({ currentStep, phone }) => {
  let bodyContent;

  if (currentStep === registerSteps.sendloginCode) {
    bodyContent = (
      <p className="text">
        برای ورود یا ثبت نام
        <br />
        <span className="text-bold">شماره موبایل</span> خود را وارد کنید:
      </p>
    );
  }

  if (currentStep === registerSteps.login) {
    bodyContent = (
      <p className="text">
        <span className="text-bold">کد چهار رقمی </span>
        ارسال شده به شماره <br />
        <span className="phone">{phone} </span>
        را وارد کنید:
      </p>
    );
  }

  if (currentStep === registerSteps.signup) {
    bodyContent = (
      <p className="text">
        این شماره موبایل ثبت نشده است
        <br />
        برای ورود لطفا <span className="text-bold">ثبت نام</span> خود را کامل
        کنید:
      </p>
    );
  }

  return <Wrapper>{bodyContent}</Wrapper>;
};

const Wrapper = styled.div`
  width: 100%;
  .text-bold {
    font-family: 'dana-bold';
    color: #753cbe;
  }
  .text {
    color: #707070;
    font-size: 18px;
    text-align: center;
    font-weight: 400;
    line-height: 36px;
  }
  .not-register {
    font-size: 17.5px;
  }
  .phone {
    color: #753cbe;
    letter-spacing: 0.5px;
  }
`;
